import React, { useCallback, useContext, RefObject } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IFileWithMeta } from 'react-dropzone-uploader/dist/Dropzone';

import { checkAccepts } from '../../../utility/helpers';
import { selectLists } from '../../../store/modules/lists/selectors';
import { UploadContext } from '../tab-media/useUploadFiles';
import { setOpenMediaUpload } from '../../../store/modules/articles/actions';

/* eslint-disable no-continue, no-plusplus  */

const UploadFilesAction = ({ refInput }: {refInput: RefObject<HTMLInputElement>}) => {
  const dispatch = useDispatch();
  const { addFile } = useContext(UploadContext);
  const lists = useSelector(selectLists);
  const accepts = lists.data ? lists.data['document-mime-types']
    .map((item) => `.${item.extension.toLocaleLowerCase()}`).join(',') : '*';

  const handleFile = useCallback((file: File) => {
    const {
      name, size, type, lastModified,
    } = file;

    const uploadedDate = new Date().toISOString();
    const lastModifiedDate = lastModified && new Date(lastModified).toISOString();
    return {
      file,
      meta: {
        name, size, type, lastModifiedDate, uploadedDate, percent: 0, id: '', status: 'ready',
      },
    } as IFileWithMeta;
  }, []);

  const onChange = useCallback(async (e: React.ChangeEvent<HTMLInputElement>) => {
    const { target } = e;
    if (target && target.files) {
      const items = e.target.files;
      if (items) {
        for (let l = items.length, i = 0; i < l; i++) {
          if (!checkAccepts(items[i], accepts)) {
            continue;
          }
          addFile(handleFile(items[i]));
        }
      }
      // @ts-ignore
      target.value = null;
      dispatch(setOpenMediaUpload(true));
    }
  }, [handleFile, accepts, addFile, dispatch]);

  return (
    <input
      ref={refInput}
      hidden
      type="file"
      accept={accepts}
      multiple
      onChange={onChange}
    />
  );
};

export default UploadFilesAction;
